import useCollection from "areas/collection/hoc/use-collection"
import { IS_JEWLR } from "helpers/application"
import { cn } from "styles/utils"

import Breadcrumb from "./breadcrumb"
import Description from "./description"

const Heading = () => {
  const { data: { pagination: { total_product_count } = {}, title } = {} } =
    useCollection()

  return (
    <>
      <div
        className={cn(
          "mb-16 flex items-start",
          IS_JEWLR() ? "justify-between" : "justify-end"
        )}
      >
        {IS_JEWLR() ? (
          <Breadcrumb />
        ) : (
          <div aria-atomic aria-live="polite">
            <span className="text-14 text-grey-500">
              {total_product_count} Products
            </span>
          </div>
        )}
      </div>
      <div className="desktop:w-3/4 pb-8">
        <h1 className="h3 mb-10 font-bold">{title}</h1>
        <Description />
      </div>
    </>
  )
}
export default Heading
